/**
 * Editorial event markers shown as dots on the KPOW history chart. These are
 * curated by the team (not produced by the API), so they live here as a
 * static list. Each entry's `ts` is a Unix-second timestamp aligned with the
 * history point cadence.
 */

export interface KpowAnnotation {
    /** Unix seconds, aligned with history point timestamps. */
    ts: number;
    label: string;
}

/** Noon-UTC timestamp for a given calendar date, in Unix seconds. */
const day = (year: number, month: number, date: number): number =>
    Math.floor(Date.UTC(year, month - 1, date, 12, 0, 0) / 1000);

export const kpowAnnotations: KpowAnnotation[] = [
    { ts: day(2025, 11, 4), label: 'VA, NJ, & NYC Elections' },
    { ts: day(2025, 12, 2), label: 'TN-07 Special Election' },
    { ts: day(2026, 1, 21), label: 'ICE protests in Minneapolis intensify' },
    { ts: day(2026, 2, 28), label: 'US military operation in Iran' },
    { ts: day(2026, 4, 29), label: 'Supreme Court decision in Louisiana v. Callais' },
    { ts: day(2026, 5, 8), label: 'Virginia Supreme Court nullifies Democratic redistricting effort' },
];
